<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <h2 class="page_main_title">
        費用及撥款說明
      </h2>

      <TermsDataTable
        page-table-class="page_table_terms"
        table-title="合作條件"
        :table-data="termTableData"
        class="payment_fee_table"
      />

      <div class="receive_contact">
        <ul class="receive_contact_text">
          <li>
            <span>使用合作銀行免匯款手續費，查看</span>
            <span>
              <router-link
                class="link_btn"
                to="/partner_bank"
              >合作銀行</router-link>
            </span>。
          </li>
          <li>如您有大型連鎖商店的合作需求，可直接來信留下聯絡方式，我們將由專人為您服務，謝謝。</li>
        </ul>

        <div class="receive_contact_link">
          <span class="receive_contact_icon" />
          <a
            href="mailto:pxpayplus_bd@pxpayplus.com"
            class="receive_contact_mail"
          >
            pxpayplus_bd@pxpayplus.com
          </a>
        </div>
      </div>
    </div>

    <component :is="dialogName">
      <template
        v-if="store.state.dialog.actionType === 'computeCaption'"
        #content
      >
        <div class="compute_caption_block">
          <div class="compute_caption_title">
            【手續費計算方式】
          </div>

          <p class="compute_caption_info">
            單筆手續費金額 = 訂單金額 x 費率，四捨五入至小數點二位
            <br>
            總手續費 = 單筆手續費加總，四捨五入至整數位
            <br>
            撥款金額 = 總訂單金額 - 總手續費
            <br>
            <br>
            <span>※ 以上計算不含銀行匯款手續費</span>
          </p>
        </div>

        <div class="compute_caption_block">
          <div class="compute_caption_title">
            【以簽訂費率 2.5%為例】
          </div>

          <p class="compute_caption_info">
            若消費者使用全支付，分別支付A訂單410元及B訂單205元
            <br>
            A訂單手續費：410 x 2.5% = 10.25
            <br>
            B訂單手續費：205 x 2.5% = 5.125，四捨五入為5.13
            <br>
            總手續費：10.25 + 5.13 = 15.38，四捨五入為15
            <br>
            撥款金額：(410+205) - 15 = 600元
          </p>
        </div>
      </template>
    </component>
  </div>
</template>

<script>
import { reactive } from 'vue';
import { msgDialogControl } from '@/libs/global';
import { AppDialog } from '@/components/Modal';
import TermsDataTable from '@/components/Layout/TermsDataTable';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'PaymentFee',
  components: {
    TermsDataTable,
    AppDialog
  },
  setup () {
    const { store, dialogName } = useCommon();

    const termTableData = reactive({
      header: [
        {
          text: '會員付款工具'
        },
        {
          text: '行動支付收款'
        },
        {
          text: '手續費計算'
        },
        {
          text: '請撥款說明'
        }
      ],
      data: [
        {
          col1: {
            text: '全支付帳戶'
          },
          col2: {
            text: '2.5%/筆',
            rowspan: 3
          },
          col3: {
            text: '計算範例',
            rowspan: 3,
            textClass: 'link_btn',
            clickHandle: () => {
              openComputeModal();
            }
          },
          col4: {
            text: '提供自動結算請款及多樣化的週期設定',
            rowspan: 3
          }
        },
        {
          col1: {
            text: '直連銀行帳戶'
          }
        },
        {
          col1: {
            text: '信用卡'
          }
        }
      ]
    });

    const openComputeModal = () => {
      msgDialogControl(
        {
          header: '',
          message: 'a',
          dialogType: 'disabled_pop',
          isShowCloseBtn: 'show',
          isShowHeader: true,
          width: 900
        }, 'AppDialog', 'computeCaption');
    };

    return {
      termTableData,
      dialogName,
      store
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .container_wrapper {
    .page_main_title {
      margin: 0px 0px 20px;
    }

    .terms_content {
      @include font-size-16;

      color: $mono_80;
      letter-spacing: 1px;
      white-space: pre-wrap;
      word-wrap: break-word;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }

  .payment_fee_table {
    margin-bottom: 50px;
  }

  .receive_contact {
    background-color: $mono_10;
    margin-top: 50px;
    padding: 40px 48px;

    .receive_contact_text {
      color: $black;
      font-size: 16px;
      line-height: normal;
      margin: 0px;
      padding-left: 16px;

      li {
        margin-bottom: 10px;
      }
    }

    .receive_contact_icon {
      background: url('~@/assets/imgs/common/icon-mail-active@3x.png') no-repeat center center;
      background-size: contain;
      display: inline-block;
      height: 20px;
      margin-right: 8px;
      vertical-align: middle;
      width: 20px;
    }

    .receive_contact_mail {
      color: $black;
      cursor: pointer;
      font-size: 15px;
      font-weight: 700;
      text-decoration: none;
      vertical-align: middle;
    }
  }

  ::v-deep(.web_dialog) {
    .p-dialog {
      max-width: 900px;

      h5 {
        display: none;
      }

      .p-dialog-content {
        padding-top: 0;
      }
    }
  }

  .compute_caption_block {
    color: $black;
    text-align: left;

    &:not(:last-child) {
      margin-bottom: 40px;
    }

    .compute_caption_title {
      @include font-size-bold-24;

      margin-bottom: 20px;
    }

    .compute_caption_info {
      font-size: 20px;
    }
  }

  ::v-deep(.link_btn) {
    color: $green;
    cursor: pointer;
    font-size: 16px;
    text-decoration: none;
  }
}

@include RWD_1024 {
  ::v-deep(.web_dialog) {
    .p-dialog {
      max-width: 824px !important;
    }
  }
}

@include RWD_768 {
  .layout_wrapper {
    .receive_contact {
      padding: 38px 42px;
    }
  }

  ::v-deep(.web_dialog) {
    .p-dialog {
      max-width: calc(100% - 100px) !important;
    }
  }
}

@include RWD_414 {
  .layout_wrapper {
    .page_main_title {
      margin: 0px 0px 28px;
    }

    .receive_contact {
      background-color: $mono_10;
      margin-top: 30px;
      padding: 20px;

      .receive_contact_text {
        font-size: 13px;
        margin-bottom: 14px;
      }

      .receive_contact_mail {
        font-size: 13px;
      }

      .link_btn {
        font-size: 13px;
      }
    }
  }

  ::v-deep(.web_dialog) {
    .p-dialog {
      max-width: calc(100% - 100px) !important;
      padding: 0 30px;
    }
  }
}

@media only screen and (max-width: 414px) {
  .layout_wrapper {
    ::v-deep(.web_dialog) {
      .p-dialog {
        max-height: 553px;
        max-width: calc(100% - 60px) !important;
        padding: 0 30px;
      }
    }

    .compute_caption_block {
      .compute_caption_title {
        font-size: 20px;
      }

      .compute_caption_info {
        font-size: 16px;
      }
    }
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 767px) {
  #app {
    min-height: calc(100vh - 70px - 621px);
  }
}
</style>
